var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrowWhite = function SvgDownArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.146.774a.5.5 0 0 1 .708 0L5.5 5.421 10.146.774a.5.5 0 1 1 .707.708l-5 5a.5.5 0 0 1-.707 0l-5-5a.5.5 0 0 1 0-.708Z",
    fill: "currentColor"
  })));
};
export default SvgDownArrowWhite;